import { apiClient } from './apiClient';
import type { DevRankedClientDto } from '../pages/DevRanking/types';

export type BatchScalingStatValue = 'Max' | 'Mean' | 'Median' | 'P90' | 'P95';

export interface ScorerWeights {
    weightDelay: number;
    weightAmount: number;
    weightComplexity: number;
    weightCredit: number;
    weightHistory: number;
    amountScalingStat: BatchScalingStatValue;
    daysOverdueScalingStat: BatchScalingStatValue;
}

export const DEFAULT_SCORER_WEIGHTS: ScorerWeights = {
    weightDelay:           2.00,
    weightAmount:          2.00,
    weightComplexity:      0.25,
    weightCredit:          1.00,
    weightHistory:         0.20,
    amountScalingStat:     'Max',
    daysOverdueScalingStat: 'P95',
};

const getScoringOptions = (): Promise<ScorerWeights> =>
    apiClient.get<ScorerWeights>('/dev/tasks/scoring-options');

const getRankPreview = (weights: ScorerWeights): Promise<DevRankedClientDto[]> =>
    apiClient.post<DevRankedClientDto[]>('/dev/tasks/rank-preview', weights);

export const devRankingService = { getScoringOptions, getRankPreview };
